var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 20H16.5C17.1857 20 18 19.15 18 18.5V8.5C18 7.85 17.1857 7 16.5 7H14C13.3143 7 13 7.43333 13 8.08333C13 8.73333 13.3143 9.16667 14 9.16667H15.7143L15.7143 17.8333H4.28571L4.28571 9.16667H6C6.68571 9.16667 7 8.73333 7 8.08333C7 7.43333 6.68571 7 6 7H3.5C2.81429 7 2 7.85 2 8.5L2 18.5C2 19.15 2.81429 20 3.5 20Z",
    fill: "#F86557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.90078 6.5L9.00078 5.40001L9.00078 13C9.00078 13.6 9.40078 14 10.0008 14C10.6008 14 11.0008 13.6 11.0008 13L11.0008 5.40001L12.1008 6.5C12.5008 6.9 13.1008 6.9 13.5008 6.5C13.9008 6.10001 13.9008 5.5 13.5008 5.10001L10.7008 2.3C10.3008 1.90001 9.70078 1.90001 9.30078 2.3L6.50078 5.10001C6.10078 5.5 6.10078 6.10001 6.50078 6.5C6.90078 6.9 7.50078 6.9 7.90078 6.5Z",
    fill: "#F86557"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.22e50d328683814320bfd0d03d787a23.svg";
export { ForwardRef as ReactComponent };